import { createFeatureSelector, createSelector } from '@ngrx/store';

import { driversGroupsAdapter, DriversGroupsState } from '@store/driversGroups/driversGroups.state';

export const selectDriversGroupsState = createFeatureSelector<DriversGroupsState>('driversGroups');

const { selectAll, selectEntities, selectIds } =
  driversGroupsAdapter.getSelectors(selectDriversGroupsState);
export const selectAllDriversGroups = selectAll;
export const selectDriversGroupsEntities = selectEntities;
export const selectDriversGroupsIds = selectIds;
export const selectLoadingDriversGroupsList = createSelector(
  selectDriversGroupsState,
  (state) => state.loading,
);

export const selectDriversGroupById = (id: string | number) =>
  createSelector(selectDriversGroupsEntities, (entities) => entities[id]);
